((Drupal) => {
  "use strict";

  Drupal.behaviors.accountsPages = {
    attach(context) {
      const handleButtonClick = (buttonSelector, showSelector) => {
        const button = context.querySelector(buttonSelector);
        if (button && !button.dataset.onceAccountsPages) {
          button.dataset.onceAccountsPages = true;
          button.addEventListener("click", (event) => {
            event.preventDefault();
            toggleVisibility(showSelector);
          });
        }
      };

      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      };

      const toggleVisibility = (showSelector) => {
        const allSections = [
          "#accountsUserList",
          "#accountsUploadForm",
          "#accounts-update-users-form",
          "#accountsStudentForm",
        ];
        allSections.forEach((selector) => {
          document
            .querySelector(selector)
            ?.classList.toggle("show", selector === showSelector);
        });
        scrollToTop();
      };

      // Configure button actions
      handleButtonClick("#accountsImportUsers", "#accountsUploadForm");
      handleButtonClick(
        "#accounts-update-users",
        "#accounts-update-users-form"
      );
      handleButtonClick("#accountsAddUser", "#accountsStudentForm");
      handleButtonClick("#accountsUploadFormCancel", "#accountsUserList");
      handleButtonClick("#accounts-update-form-cancel", "#accountsUserList");
      handleButtonClick("#accountsSchoolsAddUser", "#accountsUserList");
    },
  };
})(Drupal);
